<template>
  <table 
    class="table has-small-font mt-3"
    :class="{ 'is-fullwidth': isFullwidth }">

    <thead>
      <tr class="has-text-centered">
        <th
          v-for="(header, i) in headers"
          :key="i"
          :class="header.class">
          {{ header.label }}
        </th>
      </tr>
    </thead>

    <tbody>
      <tr>
        <td class="price--item">SUPPLY</td>
        <td class="price--description">Material and Fabrication</td>
        <td class="price--cost">
          {{ supplyPrice | currency(0) }}
        </td>
      </tr>
      <tr v-if="estimation.items.map(d => d.installations).flat(1).length > 0">
        <td class="price--item">INSTALL</td>
        <td class="price--description">Material and Labour</td>
        <td class="price--cost">
          {{ estimation.total_installation_price | currency(0) }}
        </td>
      </tr>
      <tr v-if="estimation.services.length > 0">
        <td class="price--item">SERVICES</td>
        <td class="price--description">Engineering and Delivery</td>
        <td class="price--cost">
          {{ estimation.total_service_price | currency(0) }}
        </td>
      </tr>
    </tbody>

    <tfoot>
      <tr
        class="v-centered price--total">
        <td colspan=2>
          TOTAL
        </td>
        <td class="has-text-centered">
          {{ estimation.total_price_pre_tax | currency(0) }}
        </td>
      </tr>
      <tr
        class="v-centered price--total">
        <td colspan=2>
          HST
        </td>
        <td class="has-text-centered">
          {{ estimation.total_price_post_tax - estimation.total_price_pre_tax | currency(0) }}
        </td>
      </tr>
      <tr
        class="v-centered price--grand-total">
        <td colspan=2>
          TOTAL INCLUDING HST
        </td>
        <td class="has-text-centered">
          {{ estimation.total_price_post_tax | currency(0) }}
        </td>
      </tr>
    </tfoot>
  </table>
</template>

<script>
export default {
  props: {
    estimation: {
      type: Object
    },
    isFullwidth: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      headers: [
        { label: 'ITEM', class: 'price--item' },
        { label: 'DESCRIPTION', class: 'price--description' },
        { label: 'COST', class: 'price--cost' },
      ]
    }
  },
  computed: {
    supplyPrice({ estimation }) {
      return parseFloat(estimation.total_material_price) + 
        parseFloat(estimation.total_processing_price) +
        parseFloat(estimation.total_fabrication_price)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/flexbox.scss';
@import '@/styles/table.scss';

.table {
  width: calc(
    var(--pagedjs-width) - 
    var(--pagedjs-margin-right) - 
    var(--pagedjs-margin-left)
  );

  .price {
    &--item {
      background: #0E4E74;
      color: #fff;
      text-align: center;
      font-weight: bold;
    }

    &--description {
      color: #0E4E74;
      background: #B5D1DE;
      text-align: center;
    }

    &--cost {
      background: #0E4E74;
      color: #fff;
      text-align: center;
      font-weight: bold;
    }
    &--total {
      td {
        color: #0E4E74;
      }
    }
    &--grand-total {
      background: #F16635;
      td {
        color: #fff !important;
      }
    }
  }

  tfoot {
    font-weight: bold;
  }
}
</style>